/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import { Component, OnInit } from '@angular/core';
import { CookieService } from '../services/cookie.service';
import { UserService } from '../services/user.service';

@Component({
  selector: 'app-cookie-consent',
  templateUrl: './cookie-consent.component.html',
  styleUrls: [
    './cookie-consent.component.less',
    '../../styles/appTheme-xids.scss',
  ],
  standalone: false,
})
export class CookieConsentComponent implements OnInit {
  showNotice: boolean;

  constructor(
    private cookieService: CookieService,
    private userService: UserService,
  ) {
    this.showNotice =
      sessionStorage.getItem('CookieNoticeAcknowledged') === 'true'
        ? false
        : true;
    //this.cookieService.isConsented ? this.showNotice = false : this.showNotice = true;
  }

  ngOnInit() {
    this.userService.userLoggedOff.subscribe(() => (this.showNotice = true));
    this.userService.userLoginFailed.subscribe(() => (this.showNotice = true));
  }

  close() {
    this.showNotice = false;
    sessionStorage.setItem('CookieNoticeAcknowledged', 'true');
  }
}
